export default "__VITE_ASSET__Brj$lXii__"